import ShortAppPreload from './ShortAppPreload';

export default ShortAppPreload;
